import React, { Component, ReactNode } from 'react';

import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import { withStyles } from '@material-ui/core/styles';
import { WithStyles, createStyles, Dialog } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';


import { Collapse, Paper, Typography } from '@material-ui/core';

export const WIDTH_NORMAL = 'normal';
export const WIDTH_WIDE = 'large';

const styles = (theme: Theme) => createStyles({});

interface ModalComponentProps extends WithStyles<typeof styles> {
    component?: any;
}


interface ModalComponentState {}


class ModalComponent extends Component<ModalComponentProps, ModalComponentState>{

    constructor(props: ModalComponentProps, state: ModalComponentState) {
        super(props);
    }



    render() {
      const {
        component: Component,
      } = this.props;
        return (
          <>
          <Dialog
          maxWidth={'md'}
          disableBackdropClick={true}
          disableEscapeKeyDown={true}
          aria-labelledby="dialog-title"
          open={true}
        >
          <Component />
        </Dialog>
        </>
        )
    }
}


// @ts-ignore
export default withStyles(styles)(ModalComponent);


